import React from 'react';
import { cn } from "@/lib/utils";

export type EmotionLevel = -2 | -1 | 0 | 1 | 2;

interface EmotionSelectorProps {
  value: EmotionLevel;
  onChange: (value: EmotionLevel) => void;
  className?: string;
}

const emotions = [
  { value: 2, label: "Wow", color: "bg-green-500", icon: "😍" },
  { value: 1, label: "Happy", color: "bg-blue-400", icon: "😊" },
  { value: 0, label: "Neutral", color: "bg-gray-400", icon: "😐" },
  { value: -1, label: "Sad", color: "bg-orange-400", icon: "😟" },
  { value: -2, label: "Frustrated", color: "bg-red-500", icon: "😠" },
] as const;

const EmotionSelector: React.FC<EmotionSelectorProps> = ({ value, onChange, className }) => {
  return (
    <div className={cn("flex flex-col items-center gap-1", className)}>
      <div className="flex flex-col items-center gap-2 w-full">
        {emotions.map((emotion) => (
          <button
            key={emotion.value}
            type="button"
            onClick={() => onChange(emotion.value)}
            className={cn(
              "w-6 h-6 rounded-full flex items-center justify-center transition-all duration-200 group cursor-pointer",
              value === emotion.value ? "ring-2 ring-primary/30 ring-offset-2 ring-offset-background" : ""
            )}
            aria-label={emotion.label}
            title={emotion.label}
          >
            <span 
              className={cn(
                "emotion-dot", 
                emotion.color,
                "w-4 h-4 rounded-full",
                value === emotion.value ? "emotion-dot-active scale-110" : "",
                "group-hover:scale-110 transition-all duration-200"
              )} 
            />
          </button>
        ))}
      </div>
    </div>
  );
};

export default EmotionSelector;
